import { COLORS } from '@consts/general';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    container: {
        top: '50%',
        left: '50%',
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        width: '475px',
        overflow: 'hidden',
    },
    header: {
        padding: '10px',
        background: COLORS.BLUE,
    },
    content: {
        padding: '15px',
        maxHeight: '500px',
        overflowY: 'scroll',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px',
        padding: '10px',
    },
    cancelButton: { background: COLORS.GRAY_LIGHT },
});
